import { CHINESS_REGEXP_STR } from './regExp'

const chinessRegexp = new RegExp(CHINESS_REGEXP_STR)
/**
 * 计算字符串长度
 * 中文记两个长度
 * 其他字符记一个
 * @param {*} str
 */
function characterLength(str) {
    let len = 0
    while (str) {
        const match = chinessRegexp.exec(str)
        if (!match) {
            len += str.length
            str = ''
            continue
        }
        const { 0: result } = match
        len += result.length * 2
        str = str.replace(result, '')
    }
    return len
}

export default characterLength
